define('app/sdc/on/scroll/end/sdc-on-scroll-end',["$rootScope", "$timeout", "$q", "$parse"], function ($rootScope, $timeout, $q, $parse) {
	"use strict";
	return {
		require: {
			"sdcLoadingController": "^?sdc-loading"
		},
		restrict: "A",
		template: null,
		scope: false,
		controller: {
			bind: {
				"handler": "&sdcOnScrollEnd",
				"disabled": "=sdcOnScrollEndDisabled",
				"triggerFn": "=?trigger",
				"watchTrigger": "&?"
			},
			constructor: ["$scope", "$element", "$attrs", "$self", "$watch", function ($scope, $element, $attrs, vm, $watch) {
				var _isLoading = false;
				Object.defineProperties(vm, {
					visible: {
						get: function visible_get() {
							return $element.is(":visible");
						}
					}
				});

				var stopWatchCollection = $watch.controller.collection("{visible: !!this.visible, disabled: !!this.disabled}", stateChangedWatchFn);

				var stopWatch = $watch(function () { return getScrollParent()[0]; }, generateScrollParentChangedWatchFn());

				vm.triggerFn = checkedHandler;
				if (vm.watchTrigger) {
					$watch(vm.watchTrigger, checkedHandler);
				}

				function stateChangedWatchFn(newState, oldState) {
					if (newState.disabled) {
						return;
					}
					else if (newState.visible) {
						uncheckedHandler();
					}
				}

				function generateScrollParentChangedWatchFn() {
					var removeOldDestroyHandler = angular.noop;
					var removeOldScrollHandler = angular.noop;

					return function (newScrollParent, oldScrollParent) {
						if (newScrollParent !== oldScrollParent) {
							console.info("ScrollParentChanged")
						}
						newScrollParent = angular.element(newScrollParent);
						oldScrollParent = angular.element(oldScrollParent);

						removeOldDestroyHandler();
						removeOldScrollHandler();

						newScrollParent.on("scroll", checkedHandler);

						removeOldScrollHandler = newScrollParent.off.bind(newScrollParent, 'scroll', checkedHandler);
						removeOldDestroyHandler = $scope.$on('$destroy', function () {
							removeOldScrollHandler();
						});

						_finished = function _finished() {
							removeOldDestroyHandler();
							removeOldScrollHandler();
						}
					}
				}
				function getScrollParent() {
					var returnValue;
					$element.parents().each(function () {
						var current = angular.element(this);
						switch (current.css("overflow-y")) {
							case "scroll":
							case "auto":
								returnValue = current;
								return false;
						}
						if (this === window) {
							returnValue = current;
							return false;
						}
					});
					return returnValue;
				}
				function _finished() {

				}

				function finished() {
					stopWatch();
					stopWatchCollection();
					_finished();
				}

				function uncheckedHandler() {
					// Don't allow the handler to be triggered twice.
					if (_isLoading) {
						return;
					}
					else {
						_isLoading = true;
					}
					try {
						var scrollParent = getScrollParent();

						var scrollParentHeight = scrollParent.height();

						var scrollParentBottom = scrollParent.offset().top + scrollParentHeight;
						var elementBottom = $element.offset().top + $element.height();
						var remaining = scrollParentBottom - elementBottom;
						var triggerHandler = remaining >= 0;
						if (triggerHandler) {
							var loading = $q.when(vm.handler()).finally(function () {
								_isLoading = false;
							})
								.then(function (result) {
									if (result || result === undefined) {
										$timeout(function () {
											checkedHandler();
										});
									}
									else {
										finished();
									}
								});
							if (vm.sdcLoadingController) {
								vm.sdcLoadingController.Loading = loading;
							}
						}
						else {
							_isLoading = false;
						}
					}
					catch (ex) {
						_isLoading = false;
						throw ex;
					}
				}
				function checkedHandler() {
					if (vm.disabled || !vm.visible) {
						return;
					}
					return uncheckedHandler.apply(this, arguments);
				}
			}]
		}
	};
});
